import { useEffect, useState } from "react";
import { useStyles } from "../ConnectionBar.styles";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import NoData from "components/NoData/NoData.view";
import { getDowntimeDurationInHoursMinutes } from "utilities/utilities";
import { IGetLocalserverStatusDetailsReturn } from "entities/MillLocalserver/MillLocalserverEntityInterfaces";

export const Bar = ({ data }: { data: IGetLocalserverStatusDetailsReturn["statusAverages"] }) => {
    const [connectedPercentage, setConnectedPercentage] = useState<number | null>(0);
    const [disconnectedPercentage, setDisconnectedPercentage] = useState<number | null>(0);
    const classes = useStyles();

    useEffect(() => {
        if (data) {
            const rawConnectedPercentage = (Number(data.connected_seconds) / data.total_seconds) * 100;

            const connected =
                rawConnectedPercentage >= 99 ? Math.floor(rawConnectedPercentage) : Math.ceil(rawConnectedPercentage);
            const disconnected = 100 - connected;

            setConnectedPercentage(connected);
            setDisconnectedPercentage(disconnected);
        }
    }, [data]);

    return (
        <Box className={classes.barContainer}>
            {data ? (
                <div className={`${classes.barWrapper}`}>
                    <Box className={`${classes.progressBar} ${classes.progressBarWidth}`}>
                        {data.connected_seconds !== 0 && (
                            <Box
                                className={`${classes.connectedBar} ${classes.progressBarSection}`}
                                sx={{ width: `${connectedPercentage}%` }}
                            >
                                <span className={classes.amountConnected}>
                                    <Typography variant="h5">{`${getDowntimeDurationInHoursMinutes(
                                        data.connected_seconds,
                                        true,
                                    )} ${`(${connectedPercentage}%)`}`}</Typography>
                                </span>
                            </Box>
                        )}
                        {data.disconnected_seconds !== 0 && (
                            <Box
                                className={`${classes.disconnectedBar} ${classes.progressBarSection}`}
                                sx={{ width: `${disconnectedPercentage}%` }}
                            >
                                {disconnectedPercentage && disconnectedPercentage > 0 && (
                                    <span className={classes.amountDisconnected}>
                                        <Typography variant="h5">{`${getDowntimeDurationInHoursMinutes(
                                            data.disconnected_seconds,
                                            true,
                                        )} ${`(${disconnectedPercentage}%)`}`}</Typography>
                                    </span>
                                )}
                            </Box>
                        )}
                    </Box>
                </div>
            ) : (
                <Box className={classes.noData}>
                    <NoData />
                </Box>
            )}
        </Box>
    );
};
